module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon06.2a8d2d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon06.png
// module id = AYIj
// module chunks = 0